import './contentContainer.css';

function ContentContainer({children}) {

  return (
    <div className="content-container">
      {children}
    </div>
  )
}

export default ContentContainer;